export const LOG_STATUS = {
  UNRESOLVED: 'unresolved',
  RESOLVED: 'resolved',
  SUPPORT_REQUESTED: 'supportRequested',
};
